import { OrgChart } from '../components/OrgChartNew';

export function OrganizationPage() {
  return <OrgChart />;
}
